import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ProfileProductFavorite" })
export default class ProfileProductFavorite extends Vue {
    public localizer: any = Localizer;
    public isFavorite: boolean = false;
    public isLoading: boolean = true;

    @Prop() readonly orderCode: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        const result = (await Axios.post(this.routes.ProfileFavorite_IsFavorite, { productOrderCode: this.orderCode })).data;
        this.isFavorite = result.isFavorite;
        this.isLoading = false;
    }

    public async addToFavorite() {
        this.isLoading = true;
        const result = (await Axios.post(this.routes.ProfileFavorite_FavoriteAdd, { productOrderCode: this.orderCode })).data;

        GTagHelper.sendEvent("click", "family_interaction", "favourite");
        
        this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.AddedToFavorite"), type: "Success" });
        
        this.isFavorite = true;
        this.isLoading = false;
    }
    
    public async removeToFavorite() {
        this.isLoading = true;
        const result = (await Axios.post(this.routes.ProfileFavorite_FavoriteRemove, { productOrderCode: this.orderCode })).data;

        GTagHelper.sendEvent("click", "family_interaction", "favourite_remove");

        this.$store.dispatch("appToastStore/onAddToast", { message: this.localizer.get("App.Common.RemovedToFavorite"), type: "Success" });

        this.isFavorite = false;
        this.isLoading = false;
    }
}